var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 458 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#E37222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.1 0L140.8 98.6 141.2 98.6 165.9 0 194.9 0 166.3 107.8C162.8 121.2 157.1 130.6 140.8 130.6 124.5 130.6 118.8 121.2 115.3 107.8L89.1 0 118.1 0M205.1 130.3L205 0 232.2 0 232.3 130.3 205.1 130.3M250.1 130.3L250.3 0 296.2 0C321.2 0 355.5 25.3 355.5 67.1 355.5 104.9 326.8 130.3 292.7 130.3L285 130.3 285 104.6 292.7 104.6C312.2 104.6 328.3 85.5 328.3 66.9 328.3 41.4 310.1 25.5 288.6 25.5L277.2 25.5 277.2 130.3 250.1 130.3M0 130.4L26.1 23.1C29.6 9.6 35.3 0.3 51.6 0.3 67.9 0.3 73.6 9.7 77.1 23.1L105.8 130.5 76.8 130.5 52 32.2 51.6 32.2 29 130.4 0 130.4M352.2 130.4L378.3 23C381.8 9.6 387.5 0.2 403.8 0.2 420.1 0.2 425.8 9.6 429.3 23L458 130.4 429 130.4 404.2 32.2 403.8 32.2 381.2 130.4 352.2 130.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/AVI.60ceab585b32ace6e35b095eb28bba21.svg";
export { ForwardRef as ReactComponent };